import { UserOutlined } from '@ant-design/icons';
import { Highlight } from '@/shared/ui/Highlight';
import { formatName } from '@/utils/search';
import type { SearchPatient } from '@/models/search';
import styles from '../../GlobalSearch.module.css';

const DROPDOWN_LIMIT = 5;

export const PatientResults = ({
  patients,
  onSelect,
  query,
  highlightIndex = -1,
  highlightOffset = 0,
}: {
  patients: SearchPatient[];
  onSelect: (path: string) => void;
  query: string;
  highlightIndex?: number;
  highlightOffset?: number;
}) => {
  if (patients.length === 0) return null;
  const visible = patients.slice(0, DROPDOWN_LIMIT);

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <UserOutlined className={styles.sectionIcon} />
        Patients
      </div>
      {visible.map((patient, idx) => (
        <div
          key={patient.uuid}
          className={`${styles.resultItem} ${highlightIndex === highlightOffset + idx ? styles.resultItemActive : ''}`}
          role="button"
          tabIndex={-1}
          onClick={() => onSelect(`/patients/${patient.uuid}`)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onSelect(`/patients/${patient.uuid}`);
          }}
        >
          <div className={`${styles.resultIcon} ${styles.patient}`}>
            <UserOutlined />
          </div>
          <div className={styles.resultContent}>
            <span className={styles.resultPrimary}>
              <Highlight
                text={formatName(patient.firstName, patient.lastName)}
                query={query}
              />
            </span>
            {patient.medicalRecordNumber && (
              <span className={styles.resultSecondary}>
                MRN:{' '}
                <Highlight text={patient.medicalRecordNumber} query={query} />
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
